import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  FormControlLabel,
  DialogActions,
  Button,
  Fade,
  Checkbox,
  Backdrop,
} from '@mui/material';

export default function ServiceSectionDialog(props) {
  const {
    onClose,
    onFilter,
    value: valueProp,
    options,
    open,
    ...other
  } = props;
  const [value, setValue] = React.useState(valueProp);
  const radioGroupRef = React.useRef(null);

  React.useEffect(() => {
    if (!open) {
      setValue(valueProp);
    }
  }, [valueProp, open]);

  const handleEntering = () => {
    if (radioGroupRef.current != null) {
      radioGroupRef.current.focus();
    }
  };

  const handleCancel = () => {
    onClose();
  };
  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      TransitionProps={{ onEntering: handleEntering }}
      open={open}
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
      {...other}
    >
      <Fade in={open}>
        <>
          <DialogTitle>Service Sections</DialogTitle>
          <DialogContent dividers>
            {options.map(option => (
              <FormControlLabel
                style={{ display: 'block' }}
                checked={value[option.id]}
                key={option.id}
                control={<Checkbox />}
                label={option.name}
                onChange={(event, checked) =>
                  setValue({ ...value, [option.id]: checked })
                }
              />
            ))}
          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleCancel}>
              Cancel
            </Button>
            <Button onClick={() => onFilter(value)}>Ok</Button>
          </DialogActions>
        </>
      </Fade>
    </Dialog>
  );
}
